import "slick-carousel/slick/slick";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import { animatedHandStar } from "@/scripts/animation-data/animatedHandStar";
import { showMore } from "@/scripts/helpers/library";
import modalShow from "@/modules/containers/modal/modal";
import contactForm from "@/modules/blocks/contact-form/index";
import lottie from "lottie-web";
import { animationData } from "@/scripts/animation-data/animatedSignatureDark";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";

const animationFirst = lottie.loadAnimation({
  animationData: animatedHandStar,
  container: document.getElementById("animatedHandStar"),
  renderer: "svg",
  loop: false,
  autoplay: true
});

const animationSecond = lottie.loadAnimation({
  animationData: animationData,
  container: document.getElementById("animatedSignatureDark"),
  renderer: "svg",
  loop: false,
  autoplay: false
});

const compareTabletHeader = () => {
  const overflowBlock = $(".table-wrapper");
  overflowBlock.scroll(function() {
    let position = $(this).scrollLeft();
    const tableTheadSticky = $(".services-comparison-table__thead.is-sticky");

    if (tableTheadSticky.length) {
      const compareHeader = ".services-comparison-table__thead .row";
      let compareHeaderWidth = $(compareHeader).width();
      $(compareHeader).css("left", "-" + position + "px");
      $(compareHeader).css("width", compareHeaderWidth + "px");
    }
  });
};

$(window).scroll(function() {
  let position = $(".table-wrapper").scrollLeft();
  const tableTheadSticky = $(".services-comparison-table__thead.is-sticky"),
    compareHeader = $(".services-comparison-table__thead .row");

  if (tableTheadSticky.length !== 1) {
    compareHeader.removeAttr("style");
  }
  if (tableTheadSticky.length) {
    compareHeader.css("left", "-" + position + "px");
  }
});

const inView = function(element) {
  const win = $(window);
  const obj = element;
  const scrollPosition = win.scrollTop();
  const visibleArea = win.scrollTop() + win.height();
  const objEndPos = obj.offset().top;

  return visibleArea >= objEndPos && scrollPosition <= objEndPos;
};

const startAnimation = () => {
  const animationTop = $(".js-ready-animate1");
  const animationBottom = $(".js-ready-animate2");

  if (animationTop.length) {
    window.addEventListener("scroll", event => {
      if (
        !$(animationTop).hasClass("already-played") &&
        inView($(animationTop))
      ) {
        animationFirst.play();
        $(animationTop).addClass("already-played");
      }
    });
  }

  if (animationBottom.length) {
    window.addEventListener("scroll", event => {
      if (
        !$(animationBottom).hasClass("already-played") &&
        inView($(animationBottom))
      ) {
        animationSecond.play();
        $(animationBottom).addClass("already-played");
      }
    });
  }
};

const initTableShowMore = () => {
  showMore(
    ".js-services-comparison-table",
    ".page-section--competition .js-button-show-more",
    undefined,
    true
  );
};

function stickyTableHeader() {
  const targetWidth = $(".services-comparison-table__tbody").width();
  $(window).scroll(function() {
    const fromTop = window.pageYOffset;
    const tableHeader = $(".services-comparison-table__thead");
    const startPoint = $(".js-services-comparison-table");
    const offsetTop = startPoint.offset().top;
    const offsetBottom = startPoint.innerHeight();
    const stopPoint = offsetTop + offsetBottom;
    const tabletBreakpoint = 960;
    const windowWidth = $(window).width();
    var marginTop = 0;
    const headerSticky = $(".pinned-header");

    if (headerSticky && tabletBreakpoint < windowWidth) {
      marginTop = 78;
    } else if (headerSticky && tabletBreakpoint > windowWidth) {
      marginTop = 76;
    } else {
      marginTop = 0;
    }

    if (
      fromTop >= offsetTop - marginTop &&
      fromTop <= stopPoint - (marginTop + tableHeader.height())
    ) {
      tableHeader.addClass("is-sticky");
      startPoint.addClass("is-active");
    } else {
      tableHeader.removeClass("is-sticky");
      startPoint.removeClass("is-active");
    }
  });

  $(".services-comparison-table__thead").css("max-width", targetWidth);

  if ($(".row-price").length === 1) {
    $(".services-comparison-table__tbody").addClass("single-price");
  }

  if (!$(".row-price").length) {
    $(".services-comparison-table__tbody").addClass("no-price");
  }
}

const reviewSlider = () => {
  const nextArrow = $(".review-slider-navigation__arrow--next"),
    prevArrow = $(".review-slider-navigation__arrow--prev"),
    slickElement = $(".js-customers-review-slider");

  slickElement.on("init reInit afterChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1,
      sumCouner = slick.$dots[0].children.length;

    if (counter === 1) {
      prevArrow.addClass("is-disable");
      prevArrow.attr("tabindex", "-1");
    } else if (counter === sumCouner) {
      nextArrow.addClass("is-disable");
      nextArrow.attr("tabindex", "-1");
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    } else {
      nextArrow.removeClass("is-disable");
      nextArrow.removeAttr("tabindex", "-1");
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    }
  });

  slickElement.slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true,
    autoplay: false,
    arrows: false,
    adaptiveHeight: true,
    speed: 600,
    swipeToSlide: false,
    fade: true,
    swipe: false,
    dots: true,
    responsive: [
      {
        breakpoint: 959,
        settings: {
          fade: false,
          swipe: true
        }
      }
    ]
  });

  nextArrow.click(function(e) {
    e.preventDefault();
    slickElement.slick("slickNext");
  });

  prevArrow.click(function(e) {
    e.preventDefault();
    slickElement.slick("slickPrev");
  });
};

$(window).resize(function() {
  const compareHeader = ".services-comparison-table__thead .row";
  $(compareHeader).css("left", "auto");
  $(compareHeader).css("width", "100%");
});

const tabsInit = (init, mode) => {
  const $window = $(window);
  const tabItem = $(".tab_content__item");
  const firstTabItem = $(".tab_content__item:first");
  const firstTabTitle = $(".tab__title:first");
  const firstTabList = $(".tabs-list__item:first");
  const tabListItem = $(".tabs-list__item");
  const firstTabBody = $(".tab__body:first");

  firstTabItem.show();
  firstTabList.addClass("is-active");

  firstTabItem.attr("aria-hidden", "false");
  firstTabList.attr("aria-selected", "true");

  tabListItem.on("click keyup", function() {
    tabItem.hide();
    tabItem.attr("aria-hidden", "true");

    const activeTab = $(this).attr("rel");
    $("#" + activeTab).fadeIn();
    $("#" + activeTab).attr("aria-hidden", "false");

    tabListItem.removeClass("is-active");
    tabListItem.attr("aria-selected", "false");
    $(this).addClass("is-active");
    $(this).attr("aria-selected", "true");
  });

  const panelTitle = $(".tab__title");
  const visibilityMode = mode || "single";
  const isInitialized = init || "init";
  const transitionTime = 170;

  if (isInitialized === "init") {
    const hidePanels = () => {
      const activeTitles = panelTitle.filter(function() {
        return $(this).attr("aria-selected") === "true";
      });

      $.each(activeTitles, function() {
        $(this).attr("aria-selected", "false");
        $(this)
          .next()
          .slideUp(transitionTime);
      });
    };

    $.each(panelTitle, function() {
      const isOpen = $(this).attr("aria-selected");

      if (isOpen === "true") {
        $(this)
          .next()
          .slideDown(transitionTime);
      } else {
        $(this)
          .next()
          .slideUp(transitionTime);
      }
    });

    if (visibilityMode === "single") {
      panelTitle.on("click", function() {
        const title = $(this);
        const panel = $(this).next();

        if (panel.length) {
          if (panel.is(":visible")) {
            $.each(panelTitle, function() {
              hidePanels();
            });
          } else {
            hidePanels();
            title.attr("aria-selected", "true");
            panel.slideDown(transitionTime);
          }
        }
      });
    } else if (visibilityMode === "multiply") {
      panelTitle.on("click", function() {
        const panel = $(this).next();

        if (panel.length) {
          panel.slideDown(transitionTime);
        } else {
          panel.slideUp(transitionTime);
        }
      });
    }
  } else {
    $(panelTitle).unbind("click");
  }
};

const scrollCustomersLogo = () => {
  const blockScrollLogo = $(".js-scroll-logo"),
    blockScrollLogoInner = $(".js-scroll-logo .partners-logos"),
    win = $(window),
    winWid = win.width(),
    mediaScreenDesktop = 960,
    mediaScreenTablet = 640,
    mediaScreenPhone = 375;

  if (winWid < mediaScreenDesktop) {
    window.addEventListener("scroll", event => {
      let logoInnerWidth = blockScrollLogoInner.width(),
        scrollPosition = win.scrollTop(),
        visibleArea = win.scrollTop() + win.height(),
        objEndPos = blockScrollLogo.offset().top;

      if (winWid < mediaScreenPhone) {
        var positionNew = -(winWid - logoInnerWidth - 50),
          heightBottomPage = visibleArea - objEndPos - 100;
      } else if (winWid < mediaScreenTablet) {
        var positionNew = -(winWid - logoInnerWidth - 40),
          heightBottomPage = visibleArea - objEndPos - 100;
      } else if (winWid < mediaScreenDesktop) {
        var positionNew = -(winWid - logoInnerWidth - 60),
          heightBottomPage = (visibleArea - objEndPos - 240) * 0.6;
      }

      if (heightBottomPage > 0 && heightBottomPage < positionNew) {
        blockScrollLogoInner.css("margin-left", "-" + heightBottomPage + "px");
      }
    });
  }
};

$(document).ready(function() {
  modalShow();
  startAnimation();
  addedLazyLoadImages();
  stickyTableHeader();
  initTableShowMore();
  reviewSlider();
  contactForm();
  compareTabletHeader();
  initWowLibrary();
  tabsInit();
  scrollCustomersLogo();

  $("[data-micromodal-trigger]").click(function(e) {
    e.preventDefault();
  });

  $(window).on("resize", function() {
    stickyTableHeader();
  });
});
